/**
 * Parse a "YYYY-MM-DD" string as a local-time Date (no UTC shift).
 * Use this everywhere you receive `course_date` from MIRA — `new Date("YYYY-MM-DD")`
 * is parsed as UTC midnight, which can render the wrong day in non-UTC timezones.
 */
export function parseLocalDate(yyyymmdd: string): Date {
  const [y, m, d] = yyyymmdd.split('-').map(Number);
  return new Date(y, m - 1, d);
}

/**
 * Format "YYYY-MM-DD" as a Danish long date (e.g. "12. maj 2026").
 */
export function formatDanishDate(yyyymmdd: string): string {
  return parseLocalDate(yyyymmdd).toLocaleDateString('da-DK', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}
